import axios from "axios";
import Swal from "sweetalert2";
import { tokenConfig } from "./websiteActions";
import { t } from "i18next";
import { re } from "mathjs";


const getNotification = () => (dispatch, getState) => {
	dispatch({ type: 'LOADING_NOTIFICATION', payload: true });
	axios.get(`/api/notification`, tokenConfig(getState)).then(res => {
		dispatch({ type: 'LOADING_NOTIFICATION', payload: false });

		if (res.data.status === 200) {
			dispatch({
				type: 'ADMIN_NOTIFICATION',
				payload: res.data.data
			});
		} else {
			Swal.fire(t("Error"), t(res.data.message), 'error');
		}
	}).catch(err => {
		dispatch({ type: 'LOADING_NOTIFICATION', payload: false });
		Swal.fire(t("Error"), t("An error occurred!"), 'error');
	});
};

const saveNotification = (data, setIsLoading) => (dispatch, getState) => {
	var body = {
		_id: data?._id,
		chat_id: data?.chat_id,
		message: data?.message,
		type: data?.type,
		discord_url: data?.discord_url,
		telegramToken: data?.telegramToken
	};
	Swal.fire({
		title: "Are you sure?",
		text: "Are you sure to edit notification?",
		icon: 'warning',
		showCancelButton: true,
		confirmButtonColor: '#3085d6',
		cancelButtonColor: '#d33',
		confirmButtonText: "Sure",
		cancelButtonText: "Cancel"
	}).then((result) => {
		if (result.value) {
			if (setIsLoading) setIsLoading(true);
			if (!setIsLoading) dispatch({ type: 'LOADING_NOTIFICATION', payload: true });
			axios.post('/api/notification', body, tokenConfig(getState)).then(res => {
				if (!setIsLoading) dispatch({ type: 'LOADING_NOTIFICATION', payload: false });
				if (res.data.status === 200) {
					if (!setIsLoading) dispatch(getNotification());
					if (setIsLoading) setIsLoading(false);
					Swal.fire("Success", res.data.message, 'success');
				} else {
					if (setIsLoading) setIsLoading(false);
					if (!setIsLoading) dispatch({ type: 'LOADING_NOTIFICATION', payload: false });
					Swal.fire("Error", res.data.message, 'error');
				}
			}).catch(err => {
				if (setIsLoading) setIsLoading(false);
				if (!setIsLoading) dispatch({ type: 'LOADING_NOTIFICATION', payload: false });
				Swal.fire("Error", "An error occurred!", 'error');
			});
		}
	})
};

const testNotification = (data) => (dispatch, getState) => {
	axios.post('/api/notification/test', data, tokenConfig(getState)).then(res => {
		if (res.data.status === 200) {
			Swal.fire("Success", res.data.message, 'success');
		} else {
			Swal.fire("Error", res.data.message, 'error');
		}
	}).catch(err => {
		Swal.fire("Error", "An error occurred!", 'error');
	});
};

const getNotificationMessage = () => (dispatch, getState) => {
	dispatch({ type: 'LOADING_NOTIFICATION', payload: true });
	return axios.get(`/api/notification/message`, tokenConfig(getState)).then(res => {
		dispatch({ type: 'LOADING_NOTIFICATION', payload: false });

		if (res.data.status === 200) {
			return res.data.data;
		} else {
			dispatch({ type: 'LOADING_NOTIFICATION', payload: false });
			return null;
		}
	}).catch(err => {
		dispatch({ type: 'LOADING_NOTIFICATION', payload: false });
		return null;
	});
};

export {
	getNotification,
	saveNotification,
	testNotification,
	getNotificationMessage
};
